import { render, staticRenderFns } from "./filter-attribution-tag.vue?vue&type=template&id=358031b3"
import script from "./filter-attribution-tag.vue?vue&type=script&lang=js"
export * from "./filter-attribution-tag.vue?vue&type=script&lang=js"
import style0 from "./filter-attribution-tag.vue?vue&type=style&index=0&id=358031b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports